import { NgModule } from '@angular/core';
import { ZefTranslationsService } from '@zerops/zef/translations';
import { FEATURE_NAME } from './project-env-add-dialog.constant';

const en = {
  saveButtonTitle: 'Save new custom variable',
  addSuccess: 'Project custom environment variable was added successfully.'
};

export type ProjectEnvAddDialogTranslations = typeof en;

@NgModule()
export class ProjectEnvAddDialogTranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
